import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, BookOpen, MessageSquare, Trophy, User } from 'lucide-react';
import { cn } from '../../lib/utils';

const navItems = [
  { path: '/', icon: Home, label: 'Início' },
  { path: '/tracks', icon: BookOpen, label: 'Trilhas' },
  { path: '/phrases', icon: MessageSquare, label: 'Frases' },
  { path: '/achievements', icon: Trophy, label: 'Conquistas' },
  { path: '/profile', icon: User, label: 'Perfil' },
];

const MobileNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="mobile-nav safe-area-bottom md:hidden">
      <div className="flex items-center justify-around">
        {navItems.map(({ path, icon: Icon, label }) => {
          const isActive = location.pathname === path;
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              className={cn(
                'nav-item flex-1 max-w-[80px]',
                isActive && 'active'
              )}
            >
              <Icon
                className={cn(
                  'w-5 h-5 transition-colors',
                  isActive ? 'text-primary' : 'text-muted-foreground'
                )}
              />
              <span
                className={cn(
                  'text-xs font-medium transition-colors',
                  isActive ? 'text-primary' : 'text-muted-foreground'
                )}
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;
